import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconAttach: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        d="M5.36116 20.3995C3.54628 18.5847 3.54628 15.6383 5.36116 13.8236L15.2254 3.95936C16.5045 2.68021 18.5882 2.68021 19.8673 3.95936C21.1464 5.23851 21.1465 7.32222 19.8673 8.60132L10.0031 18.4655C9.25975 19.2089 8.03863 19.2089 7.29526 18.4655C6.55189 17.7222 6.55189 16.501 7.29526 15.7577L15.8055 7.24744H15.8057C15.9078 7.14232 16.0476 7.08259 16.194 7.08164C16.3405 7.08069 16.4813 7.13831 16.5847 7.24191C16.6883 7.34551 16.7461 7.48613 16.745 7.63267C16.744 7.77901 16.6843 7.91906 16.5792 8.02114L8.06895 16.5314C7.74078 16.8595 7.74078 17.3636 8.06895 17.6918C8.39713 18.02 8.90122 18.02 9.22941 17.6918L19.0936 7.82761C19.9576 6.96365 19.9576 5.59677 19.0936 4.73305C18.2296 3.86909 16.8628 3.86909 15.999 4.73305L6.13485 14.5973C4.73515 15.9969 4.73515 18.2265 6.13485 19.6258C7.53454 21.0255 9.76406 21.0255 11.1634 19.6258L20.0605 10.7287C20.1626 10.6238 20.3024 10.5641 20.449 10.5629C20.5953 10.562 20.7361 10.6196 20.8397 10.7232C20.9433 10.8268 21.0009 10.9676 21 11.114C20.9988 11.2605 20.9391 11.4004 20.8342 11.5024L11.9371 20.3995C10.1222 22.2144 7.17587 22.2144 5.36114 20.3995L5.36116 20.3995Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconAttach;
